import { render, staticRenderFns } from "./UserBookings.vue?vue&type=template&id=345f1c1f"
import script from "./UserBookings.vue?vue&type=script&lang=js"
export * from "./UserBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports